"use client";

import { Button } from "@/components/ui/button";
import Image from "next/image";
import React from "react";
import HeroImage from "@/assets/Images/hero.png";
import ArrowRight from "@/assets/Icons/arrowRight";
import PlayIcon from "@/assets/playIcon";
import Link from "next/link";

const Hero = () => {
  return (
    <div className="min-h-screen container mx-auto  pt-24  flex md:flex-row flex-col gap-5 items-center justify-center ">
      <div className="left w-full md:w-1/2">
        <div className="flex flex-col gap-10 md:w-[590px]">
          <div className="text-3xl md:text-4xl font-semibold">
            Selamat Datang di Portal Resmi Dinas Pertanian Kabupaten Penukal
            Abab Lematang Ilir
          </div>
          <div className="text-[#70707B] text-justify text-base md:text-lg">
            Di portal ini, Anda dapat mengakses berbagai aplikasi pendukung
            petani, data kelompok tani, informasi alat dan mesin pertanian
            (ALSINTAN), hingga artikel edukatif dan pengumuman terkini seputar
            dunia pertanian.
          </div>
          <div className="flex md:flex-row flex-col gap-5 items-center">
            <Link href={`/support-apps`}>
              <Button className="px-5 py-5 w-full md:w-fit flex items-center gap-2  text-base shadow-md border text-primary bg-white hover:bg-slate-50 rounded-full">
                Jelajahi Aplikasi Pendukung
                <ArrowRight />
              </Button>
            </Link>
            <Link
              href={`https://play.google.com/store/apps/details?id=com.newustechnology.alsintan`}
              target="_blank"
            >
              <Button className="px-5 py-5 w-full md:w-fit  text-base shadow-md border bg-primary text-white rounded-full">
                <PlayIcon />
                Unduh Aplikasi ALSINTAN
              </Button>
            </Link>
          </div>
        </div>
      </div>
      <div className="right w-full md:w-1/2">
        <div className="">
          <Image alt="hero" height={1000} width={1000} src={HeroImage} />
        </div>
      </div>
    </div>
  );
};

export default Hero;
